import { render, staticRenderFns } from "./cardDetailUse.vue?vue&type=template&id=239bac8a&scoped=true"
import script from "./cardDetailUse.vue?vue&type=script&lang=js"
export * from "./cardDetailUse.vue?vue&type=script&lang=js"
import style0 from "./cardDetailUse.vue?vue&type=style&index=0&id=239bac8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239bac8a",
  null
  
)

export default component.exports